export default __webpack_public_path__ + "static/media/postgresql-vertical.85b0dba6.svg";